import React, { useEffect, useState } from 'react';
import Header from '../Components/Header'
import DashBoardHeader from '../Components/DashHeader';
import axios from "axios";
import { message } from 'antd';
import { useNavigate } from "react-router-dom";
import { Spin } from 'antd';
import {useToken} from "../context/TokenContext";
import DashBoardBodyMerchant from "../Components/DashBoardBodyMerchant";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const DashBoardMerchant = () => {
    const navigate = useNavigate();
    const [token, setToken] = useToken();
    const [username, setUsername] = useState(null)
    const [lotteryCount, setLotteryCount] = useState(null);

    async function fetchUserData() {
        try {
            const response = await axios.get(`${baseURL}/happypay/happy-merchant.php/users`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                setUsername(response.data.custname);
                setLotteryCount(response.data.lotteryCount);
            }
        } catch (error) {
            console.log(error.response.data);
            switch (error.response.status){
                case 401:
                case 404:
                    message.error("Таны мэдээлэл олдсонгүй, та дахин нэвтэрнэ үү!");
                    setToken(null);
                    navigate("/login?link=2");
            }
        }
    }

    useEffect( () => {
        if (token == null || token.length === 0) {
            navigate("/login?link=2")
        } else{
            fetchUserData().then();
        }
    }, []);


    return (
        <div className='h-full bg-slate-200 w-full '>
            <Header />
            <div className= 'w-full h-screen px-40 py-8 bg-slate-200 space-y-8 mobile:px-4 laptop:px-20'>
                {(username != null && lotteryCount != null) ? (
                    <div>
                        <DashBoardHeader name={username} />
                        <DashBoardBodyMerchant lotteryCount={lotteryCount} />
                    </div>
                ) : <Spin/>}
            </div>
        </div>
    );
}

export default DashBoardMerchant;